import { FC, PropsWithChildren } from 'react';
import { Box } from '@chakra-ui/react';

import SunshineCard, { SunshineCardProps } from 'components/_core/SunshineCard';

// padding top + padding bottom + line height = 8 + 8 + 16 = 32
const CARD_HEADER_HEIGHT = 32;

export const SunshineCardHeader: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box
      backgroundColor="grey.200"
      left={0}
      lineHeight="font-16"
      paddingBottom="space-8"
      paddingLeft="space-16"
      paddingRight="space-16"
      paddingTop="space-8"
      position="absolute"
      top={0}
      width="100%"
    >
      {children}
    </Box>
  );
};

export const SunshineCardWithHeader: FC<SunshineCardProps> = ({
  children,
  ...rest
}) => {
  return (
    <SunshineCard
      overflow="hidden"
      paddingTop={CARD_HEADER_HEIGHT + 16}
      position="relative"
      {...rest}
    >
      {children}
    </SunshineCard>
  );
};
